export const LANGUAGES = [
  "1c",
  "abnf",
  "accesslog",
  "actionscript",
  "ada",
  "angelscript",
  "apache",
  "applescript",
  "arcade",
  "arduino",
  "armasm",
  "asciidoc",
  "aspectj",
  "autohotkey",
  "autoit",
  "avrasm",
  "awk",
  "axapta",
  "bash",
  "basic",
  "bnf",
  "brainfuck",
  "cal",
  "capnproto",
  "ceylon",
  "clean",
  "clojure-repl",
  "clojure",
  "cmake",
  "coffeescript",
  "coq",
  "cos",
  "cpp",
  "crmsh",
  "crystal",
  "cs",
  "csp",
  "css",
  "d",
  "dart",
  "delphi",
  "diff",
  "django",
  "dns",
  "dockerfile",
  "dos",
  "dsconfig",
  "dts",
  "dust",
  "ebnf",
  "elixir",
  "elm",
  "erb",
  "erlang-repl",
  "erlang",
  "excel",
  "fix",
  "flix",
  "fortran",
  "fsharp",
  "gams",
  "gauss",
  "gcode",
  "gherkin",
  "glsl",
  "gml",
  "go",
  "golo",
  "gradle",
  "groovy",
  "haml",
  "handlebars",
  "haskell",
  "haxe",
  "hsp",
  "htmlbars",
  "http",
  "hy",
  "inform7",
  "ini",
  "irpf90",
  "isbl",
  "java",
  "javascript",
  "jboss-cli",
  "json",
  "julia-repl",
  "julia",
  "kotlin",
  "lasso",
  "ldif",
  "leaf",
  "less",
  "lisp",
  "livecodeserver",
  "livescript",
  "llvm",
  "lsl",
  "lua",
  "makefile",
  "markdown",
  "mathematica",
  "matlab",
  "maxima",
  "mel",
  "mercury",
  "mipsasm",
  "mizar",
  "mojolicious",
  "monkey",
  "moonscript",
  "n1ql",
  "nginx",
  "nimrod",
  "nix",
  "nsis",
  "objectivec",
  "ocaml",
  "openscad",
  "oxygene",
  "parser3",
  "perl",
  "pf",
  "pgsql",
  "php",
  "plaintext",
  "pony",
  "powershell",
  "processing",
  "profile",
  "prolog",
  "properties",
  "protobuf",
  "puppet",
  "purebasic",
  "python",
  "q",
  "qml",
  "r",
  "reasonml",
  "rib",
  "roboconf",
  "routeros",
  "rsl",
  "ruby",
  "ruleslanguage",
  "rust",
  "sas",
  "scala",
  "scheme",
  "scilab",
  "scss",
  "shell",
  "smali",
  "smalltalk",
  "sml",
  "sqf",
  "sql",
  "stan",
  "stata",
  "step21",
  "stylus",
  "subunit",
  "swift",
  "taggerscript",
  "tap",
  "tcl",
  "tex",
  "thrift",
  "tp",
  "twig",
  "typescript",
  "vala",
  "vbnet",
  "vbscript-html",
  "vbscript",
  "verilog",
  "vhdl",
  "vim",
  "x86asm",
  "xl",
  "xml",
  "xquery",
  "yaml",
  "zephir",
];

// supported terminal themes
export const THEMES = [
  "AdventureTime",
  "Afterglow",
  "AlienBlood",
  "Andromeda",
  "Argonaut",
  "Arthur",
  "AtelierSulphurpool",
  "Atom",
  "AtomOneLight",
  "ayu_light",
  "ayu",
  "Batman",
  "BirdsOfParadise",
  "Blazer",
  "BlulocoDark",
  "BlulocoLight",
  "Borland",
  "Broadcast",
  "Brogrammer",
  "C64",
  "Calamity",
  "Chalk",
  "Chalkboard",
  "ChallengerDeep",
  "Chester",
  "Ciapre",
  "CLRS",
  "Cobalt2",
  "CrayonPonyFish",
  "cyberpunk",
  "Dark+",
  "Darkside",
  "deep",
  "Desert",
  "DimmedMonokai",
  "DotGov",
  "Dracula",
  "Earthsong",
  "Elemental",
  "Elementary",
  "ENCOM",
  "Espresso",
  "Fideloper",
  "FirefoxDev",
  "Firewatch",
  "FishTank",
  "Flat",
  "Flatland",
  "Floraverse",
  "ForestBlue",
  "Framer",
  "FrontEndDelight",
  "FunForrest",
  "Galaxy",
  "Github",
  "Glacier",
  "Grape",
  "Grass",
  "Hacktober",
  "Hardcore",
  "Harper",
  "Highway",
  "Homebrew",
  "Hopscotch.256",
  "Hopscotch",
  "Hurtado",
  "Hybrid",
  "IC_Green_PPL",
  "IC_Orange_PPL",
  "idea",
  "idleToes",
  "IR_Black",
  "Japanesque",
  "Jellybeans",
  "Kibble",
  "Kolorit",
  "Lavandula",
  "LiquidCarbon",
  "LiquidCarbonTransparent",
  "LiquidCarbonTransparentInverse",
  "lovelace",
  "Material",
  "MaterialDark",
  "MaterialOcean",
  "Mathias",
  "Medallion",
  "midnight-in-mojave",
  "Misterioso",
  "Molokai",
  "MonaLisa",
  "N0tch2k",
  "Neopolitan",
  "Neutron",
  "Novel",
  "Obsidian",
  "Ocean",
  "OceanicMaterial",
  "Ollie",
  "OneHalfDark",
  "OneHalfLight",
  "Pandora",
  "PaulMillr",
  "PencilDark",
  "PencilLight",
  "Pnevma",
  "primary",
  "Pro",
  "purplepeter",
  "rebecca",
  "Relaxed",
  "Rippedcasts",
  "Royal",
  "Ryuuko",
  "SeaShells",
  "Seti",
  "shades-of-purple",
  "Shaman",
  "Slate",
  "Smyck",
  "Snazzy",
  "SoftServer",
  "Spacedust",
  "SpaceGray",
  "Spiderman",
  "Spring",
  "Square",
  "Subliminal",
  "Sundried",
  "Symfonic",
  "synthwave",
  "Teerb",
  "Tomorrow",
  "ToyChest",
  "Treehouse",
  "Twilight",
  "Ubuntu",
  "UltraViolent",
  "UnderTheSea",
  "Unikitty",
  "Urple",
  "Vaughn",
  "VibrantInk",
  "WarmNeon",
  "Wez",
  "Whimsy",
  "WildCherry",
  "Wombat",
  "Wryan",
  "Zenburn",
];
